import { CpClientDataEditConfigInterface, CpClientDataEditInterface } from '../../../interfaces/dto/client-data-edit/cp-client-data-edit-interface';

export class CpClientDataEditConfigModel implements CpClientDataEditConfigInterface {
  canEdit: boolean = true;

  constructor(init?: Partial<CpClientDataEditConfigModel>) {
    Object.assign(this, init);
  }
}

export class CpClientDataEditModel implements CpClientDataEditInterface {
  config: CpClientDataEditConfigModel = new CpClientDataEditConfigModel();

  constructor(init?: Partial<CpClientDataEditModel>) {
    Object.assign(this, init);
  }
}
